import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export class YesNoDialogData {
    icon: string;
    iconColor: string;
    title: string;
    message: string;
    yesButtonText: string;
    noButtonText: string;
}

@Component({
    selector: 'app-yes-no-dialog',
    templateUrl: './yes-no-dialog.component.html',
    styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent {
    @Output() noEvent = new EventEmitter<void>();
    @Output() yesEvent = new EventEmitter<void>();

    dialogData: YesNoDialogData;
    loading = false;

    constructor(@Inject(MAT_DIALOG_DATA) data, private dialog: MatDialogRef<YesNoDialogComponent>) {
        this.dialogData = data;
    }
}
